<template>
  <div>
    <v-row no-gutters v-for="(item, key) in formData" :key="key">
      <v-col cols="2" class="mr-4 pt-2">
        <date-picker
          v-if="key === 0"
          outlined
          dense
          :value="item.start_date"
          v-on:change="val => changeDate(val)"
        />
      </v-col>

      <v-col cols="2" class="mr-2 pt-2 mr-2">
        <v-autocomplete
          v-if="key === 0"
          dense
          :items="openOptions"
          v-on:change="val => changeOpen(val)"
          v-model="open"
          outlined
        ></v-autocomplete>
      </v-col>

      <v-col v-if="open === 'Aberto'" cols="2" class="ml-2 mr-2 pt-2">
        <time-picker
            label="Abre à(s)"
            v-on:change="val => changeOpenTime(val, key)"
            v-bind:value="item.open_time"
        />
      </v-col>

      <v-col cols="2" v-if="open === 'Aberto'" class="ml-2 mr-2 pt-2">
        <time-picker
            label="Fecha à(s)"
            v-on:change="val => changeCloseTime(val, key)"
            v-bind:value="item.close_time"
        />
      </v-col>

      <div class="pt-3">
        <v-btn
          color="primary"
          icon
          @click="removeOne($event, key)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-col
          v-if="open === 'Aberto' && formData.length === key + 1"
          cols="1"
          class="action-cols ml-2 pt-4"
      >
        <v-btn
            v-if="formData.length < limit"
            small
            color="primary"
            text
            @click="addOne"
        >
          {{ addText }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import TimePicker from '@/components/TimePicker'

const OPEN = 'Aberto'
const CLOSED = 'Fechado'
const ALWAYS_OPEN = '24 Horas'

export default {
  name: "LocationSpecialScheduleItem",
  components: {
    DatePicker,
    TimePicker
  },
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Array,
    addText: {
      type: String,
      default: 'Adicionar'
    }
  },
  data: () => ({
    open: OPEN,
    formData: {
      is_24_hours: false,
      is_closed: false,
      open_time: '',
      close_time: '',
      start_date: '',
      end_date: '',
    },
    openOptions: [OPEN, CLOSED, ALWAYS_OPEN],
  }),
  methods: {
    changeOpenTime(date, index) {
      this.formData[index].open_time = date
      this.formData[index].open = !!(this.formData[index].open_time && this.formData[index].close_time)
      this.change()
    },
    changeCloseTime(date, index) {
      this.formData[index].close_time = date
      this.formData[index].open = !!(this.formData[index].open_time && this.formData[index].close_time)
      this.change()
    },
    changeDate(date) {
      for (const item in this.formData) {
        this.formData[item].start_date = date
        this.formData[item].end_date = date
      }
      this.change()
    },
    change() {
      this.$emit('change', this.formData)
    },
    changeOpen(value) {
      for (const item in this.formData) {
        if (value === ALWAYS_OPEN) {
          this.formData[item].open_time = ''
          this.formData[item].close_time = ''
          this.formData[item].open = false
          this.formData[item].is_closed = false
          this.formData[item].is_24_hours = true
        } else if (value === CLOSED) {
          this.formData[item].open_time = ''
          this.formData[item].close_time = ''
          this.formData[item].open = false
          this.formData[item].is_closed = true
          this.formData[item].is_24_hours = false
        } else if (value === OPEN) {
          this.formData[item].open_time = ''
          this.formData[item].close_time = ''
          this.formData[item].open = true
          this.formData[item].is_closed = false
          this.formData[item].is_24_hours = false
        }
      }
      this.change()
    },
    addOne() {
      if (this.formData.length < this.limit) {
        this.formData.push({
          open_time: '',
          close_time: '',
          start_date: (this.formData[0].start_date) ? this.formData[0].start_date : '',
          end_date: (this.formData[0].end_date) ? this.formData[0].end_date : '',
          open: false,
          is_closed: false,
          is_24_hours: false
        })
        this.change()
      }
    },
    removeOne(event, index) {
      if (this.formData.length > 0 && index !== 0) {
        this.formData.splice(index, 1)
        this.change()
      } else {
        this.$emit('remove')
      }
    },
  },
  mounted() {
    if (this.value) {
      const data = JSON.parse(JSON.stringify(this.value))
      this.formData = data
      if (Array.isArray(data) && data[0].is_24_hours) {
        this.open = ALWAYS_OPEN
      } else if (data[0].is_closed) {
        this.open = CLOSED
      }  else {
        this.open = OPEN
      }
    } else {
      this.formData = [{
        open_time: '',
        close_time: '',
        is_24_hours: false
      }]
      this.open = CLOSED
    }
  }
}
</script>

<style scoped>
</style>